export default "__VITE_ASSET__CJoBCBAE__"